import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControlLabel, FormGroup, Stack, TextField, Typography } from '@mui/material';
import './style.css'
import httpClient from '../../_util/api';
import CustomizedSnackbars from '../Snackbar/SnackBar';
import { hideLoader, showLoader } from '../../Store/mainSlice';
import { useRef } from 'react';

export default function AddNotePopup(props) {
    const stdId = props.stdId
    const CNICNo = props.CNICNo
    const snackbar_Ref = useRef()
    const dispatch = useDispatch()
    const [notesData, setNotesData] = React.useState(
        {
            name: "",
            createdBy: "",
            description: ""
        }
    )

    const handleClickOpen = (scrollType) => () => {
        setScroll(scrollType);
    };

    const handleClose = () => {
        console.log("props.onClose",props.onClose())
        console.log("close");
        props.onClose()
    };

    const notesSubmitHandler = async (data, field) => {
        dispatch(showLoader())
        const res = await httpClient.post(`/students/createNotes/${CNICNo}`, notesData).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
        })

        if (res?.status === 200) {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("success", res?.data.message, "", "i-chk-circle");
        }
    }

    React.useEffect(() => {
        console.log("stdId", stdId);
    }, [])


    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <React.Fragment>
            <CustomizedSnackbars ref={snackbar_Ref} />
            <Dialog
                open={props.open}
                onClose={handleClose}
            >
                <DialogTitle id="scroll-dialog-title"><Typography variant='h5' sx={{ textAlign: "center", fontWeight: 'bold' }}>Add Note</Typography></DialogTitle>
                <DialogContent dividers={scroll === 'paper'} >
                    <Stack alignItems={'space-between'} justifyContent={'space-between'} sx={{ width: "98%", height: "32vh", marginTop: '4px' }}>
                        <TextField
                        sx={{width:'500px'}}
                            id="outlined-multiline-static"
                            label="Notes..."
                            multiline
                            rows={6}
                            value={notesData.description}
                            onChange={(e) => setNotesData({ ...notesData , description: e.target.value })}
                            variant="outlined"
                        />

                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Stack alignItems={'flex-end'} sx={{ width: '100%' }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#208146",
                                color: 'white',
                                width: '92px',
                                height: "5vh",
                                fontSize: '12px',
                                borderRadius: '12px',
                                "&:hover": {
                                    backgroundColor: "#208146",
                                },
                            }}
                            onClick={notesSubmitHandler}
                        >
                            Submit
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}